import { connect } from 'react-redux'
import { get } from 'lodash'

import { setActiveAudio } from '../../../common/actions/searchPage'
import AudioPlayerLarge from './audioPlayerLarge'

const mapStateToProps = (state, ownProps) => {
  const itemAudioSrc = get(
    ownProps,
    'item.previews.icon_with_audio_preview.mp3_url'
  )
  const { searchPage: { activeAudio } } = state

  return {
    isActive: itemAudioSrc && itemAudioSrc === activeAudio
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const itemAudioSrc = get(
    ownProps,
    'item.previews.icon_with_audio_preview.mp3_url'
  )
  return {
    onPlay: () => dispatch(setActiveAudio(itemAudioSrc))
  }
}

const AudioPlayerLargeContainer = connect(mapStateToProps, mapDispatchToProps)(
  AudioPlayerLarge
)

export default AudioPlayerLargeContainer



// WEBPACK FOOTER //
// ./client/components/audio/audioPlayerLargeContainer.js